export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig();
	const authStore = useAuthStore();
	const accessToken = useCookie("accessToken");

	const $apiFetch = $fetch.create({
		baseURL: config.public.baseUrl,
		onRequest ({ options }) {
			const headers: Record<string, string> = {};
			if (accessToken.value) {
				headers.Authorization = `Bearer ${accessToken.value}`;
			}

			options.headers = { ...headers, ...options.headers };
		},
		// @ts-ignore
		onResponseError ({ response }) {
			if (response.status === 401) {
				authStore.signOut();
				return navigateTo("/login");
			}
		}
	});

	return {
		provide: {
			apiFetch: $apiFetch
		}
	};
});
